module.exports = __webpack_public_path__ + "img/drag.45e0eb2f.svg";